// extracted by mini-css-extract-plugin
export default {"taskComment":"index_taskComment__lvw+-","rowView":"index_rowView__PzN0E","expandedParentRow":"index_expandedParentRow__L5w54","expandedTable":"index_expandedTable__bux5f"};